import { useHasRoles as uhs } from '../../shared/msal';
import { Roles } from '../../shared/types/enums/workerRoles';

/**
 * Fully qualified role-check
 * @param roles local project roles
 * @returns boolean
 */
export const useHasRoles = (roles: Roles | Roles[]) => (uhs<Roles>(roles));
